import React, { Fragment } from "react";

const SDCFilters = (props) => {
  const supplierSelectHandler = (event) => {
    props.onSelectedSupplier(event.target.value);
  };
  const civilSelectHandler = (event) => {
    props.onSelectedCivil(event.target.value);
  };
  const mechSelectHandler = (event) => {
    props.onSelectedMech(event.target.value);
  };
  const elecSelectHandler = (event) => {
    props.onSelectedElec(event.target.value);
  };
  const undergroundPipeSelectHandler = (event) => {
    props.onSelectedUndergroundPipe(event.target.value);
  };
  const packageSystemSelectHandler = (event) => {
    props.onSelectedPackageSystem(event.target.value);
  };
  const resetClickHandler = () => {
    props.onSelectedSupplier("");
    props.onSelectedCivil("");
    props.onSelectedMech("");
    props.onSelectedElec("");
    props.onSelectedUndergroundPipe("");
    props.onSelectedPackageSystem("");
  };

  return (
    // prettier-ignore
    <Fragment key="SDCFilters">
      <div className="form-group row">
        <label htmlFor="supplierSelect" className="col text-center lead">
          Supplier
        </label>

        <select
          className="form-control"
          id="supplierSelect"
          value={props.selectedSupplier}
          onChange={supplierSelectHandler}
        >
          <option value="">Please Select a Supplier</option>
          {props.SDCData.map((data) => (
            <option key={data.companyName + data.id} value={data.companyName}>
              {data.companyName}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group row">
        <label htmlFor="civilCapability" className="col text-center lead">
          Civil Design Capabilities
        </label>

        <select
          className="form-control"
          id="civilCapability"
          value={props.selectedCivil}
          onChange={civilSelectHandler}
        >
          <option value="">Please Select a Capability</option>
          <option>
            Civil engineering design for typical structures in commonly used materials (e.g. concrete), including excavating, backfilling and restoration, building works and roadworks
          </option>
          <option>
            Specialist design for marine structures including sea outfalls
          </option>
          <option>
            Specialist design of submerged water retaining structures such as caisson shafts
          </option>
          <option>
            Specialist engineering design of novel materials e.g. wood, plastics
          </option>
          <option>Building design including architectural services</option>        
          {/* {props.SDCData.map((data) =>
            data.otherCivil === "" ? (
              <Fragment key={data.id}></Fragment>
            ) : (
              <option value={data.otherCivil} key={data.otherCivil}>
                {data.otherCivil}
              </option>
            )
          )} */}
        </select>
      </div>
      <div className="form-group row">
        <label htmlFor="mechCapability" className="col text-center lead">
          Mechanical Design Capabilities
        </label>

        <select
          className="form-control"
          id="mechCapability"
          value={props.selectedMech}
          onChange={mechSelectHandler}
        >
          <option value="">Please Select a Capability</option>
          <option>
            General mechanical design activities e.g. steel structures, packaged plant, above ground pipework systems not exceeding test pressures of 16 bar or sludge with not more than 2% dry solids
          </option>
          <option>
            Specialist design of mechanical equipment handling sludge
          </option>
          <option>
            Specialist design of mechanical systems with test pressures exceeding 16 bar
          </option>
          <option>Specialist design of chemical dosing systems</option>
          <option>Specialist design of SEMD equipment</option>
          <option>
            Specialist design of equipment suitable for use in DSEAR environment
          </option>
          <option>
            Specialist design of gas pipework and systems (e.g. digesters)
          </option>
          <option>Specialist design of pneumatic systems</option>
          <option>Specialist design of stainless steel vessels</option>
          <option>Specialist structural steelwork design</option>
          <option>Specialist design of diesel storage systems</option>
          <option>
            Specialist design of building services & HVAC systems incl. odour control ducting
          </option>
          <option>Specialist design of fire protection systems</option>
          {/* {props.SDCData.map((data) =>
            data.otherMech === "" ? (
              <Fragment key={data.id}></Fragment>
            ) : (
              <option value={data.otherMech} key={data.otherMech}>
                {data.otherMech}
              </option>
            )
          )} */}
        </select>
      </div>
      <div className="form-group row">
        <label htmlFor="elecCapability" className="col text-center lead">
          Electrical Design Capabilities
        </label>

        <select
          className="form-control"
          id="elecCapability"
          value={props.selectedElec}
          onChange={elecSelectHandler}
        >
          <option value="">Please Select a Capability</option>
          <option>General electrical switchgear design</option>
          <option>Electrical installation design</option>
          <option> Specialist design of lightning protection systems</option>
          <option>
            Specialist design of ATEX installations / DSEAR environments
          </option>
          <option>Specialist design of earthing systems</option>
          <option>Specialist design involving telemetry</option>
          <option>Specialist design of SEMD equipment</option>
          <option>Specialist design of HV systems</option>

          {/* {props.SDCData.map((data) =>
            data.otherElec === "" ? (
              <Fragment key={data.id}></Fragment>
            ) : (
              <option value={data.otherElec} key={data.otherElec}>
                {data.otherElec}
              </option>
            )
          )} */}
        </select>
      </div>
      <div className="form-group row">
        <label
          htmlFor="competentUndergroundPipeline"
          className="col text-center lead"
        >
          Underground Pipeline Design Capabilities
        </label>

        <select
          className="form-control"
          id="competentUndergroundPipeline"
          value={props.selectedUndergroundPipe}
          onChange={undergroundPipeSelectHandler}
        >
          <option value="">Please Select a Capability</option>
          <option>
            Pipeline design of systems conveying water using typical materials in low pressure applications (up to 16 bar test pressure)
          </option>
          <option>
            Pipeline design of systems conveying wastewater using typical materials and with test pressures not exceeding 16 bar
          </option>
          <option>
            Specialist pipeline design involving pressures exceeding 16 bar test pressure (Water)
          </option>
          <option>
            Specialist pipeline design involving pressures exceeding 16 bar test pressure (Waste water)
          </option>
          <option>Specialist pipeline design using novel materials</option>
          <option>Specialist design work involving directional drilling</option>
          <option> Specialist tunnelling design and associated works</option>
          <option>
            Specialist pipeline design involving sludges in excess of 2% dry solids
          </option>
          <option>Specialist design of surge systems</option>

          {/* {props.SDCData.map((data) =>
            data.otherUndergroundPipeline === "" ? (
              <Fragment key={data.id}></Fragment>
            ) : (
              <option
                value={data.otherUndergroundPipeline}
                key={data.otherUndergroundPipeline}
              >
                {data.otherUndergroundPipeline}
              </option>
            )
          )} */}
        </select>
      </div>
      <div className="form-group row">
        <label
          htmlFor="competentPackageSystems"
          className="col text-center lead"
        >
          Package System Design Capabilities
        </label>

        <select
          className="form-control"
          id="competentPackageSystems"
          value={props.selectedPackageSystem}
          onChange={packageSystemSelectHandler}
        >
          <option value="">Please Select a Capability</option>
          <option>Process package design</option>
          <option>Mechanical package design</option>
          <option>Mechanical rotating equipment design</option>
          <option>Generator equipment design</option>
          <option>Odour treatment package design</option>         

          {/* {props.SDCData.map((data) =>
            data.otherPackage === "" ? (
              <Fragment key={data.id}></Fragment>
            ) : (
              <option value={data.otherPackage} key={data.otherPackage}>
                {data.otherPackage}
              </option>
            )
          )} */}
        </select>
      </div>
      <div className='col text-center'>
        <button className="btn btn-primary" onClick={resetClickHandler}>Reset Filters</button>
      </div>
    </Fragment>
  );
};

export default SDCFilters;
